import { useEffect, useState } from "react";
import { useLoaderData } from "react-router-dom";

import { DASHBOARD_KEYS } from "../../../../globalConstants";
import AppWrapper from "../../../components/cm/AppWrapper";
import SideBarMain from "../../../components/cm/SideBarMain";
import { MainNavBarEnum } from "../../../components/cm/SideBarMain/MainNavBarEnum";
import SwimLanes from "../../../components/modules/FollowUps/dashboard-swimlanes/components/SwimLanesLayout/SwimLanes";
import { statusFilterOptionsList } from "../../../components/modules/FollowUps/dashboard-swimlanes/utils/strings";
import DashboardMetrics from "../../../components/modules/FollowUps/DashboardMetrics";
import { useSaveCurrentNavigation } from "../../../hooks/useSaveCurrentNavigation";

const Template = () => {
  const { lanes = [], actionItems = {}, actionItemsCounts = {} } = useLoaderData();
  const [isLoading, setIsLoading] = useState(false);

  useSaveCurrentNavigation({ key: DASHBOARD_KEYS.dashboardId });

  useEffect(() => {
    setIsLoading(true);
    const timeout = setTimeout(() => {
      setIsLoading(false);
    }, 500);

    return () => clearTimeout(timeout);
  }, [lanes, actionItems]);

  return (
    <AppWrapper.WithSidebar sidebar={<SideBarMain activeRoute={MainNavBarEnum.DASHBOARD} />}>
      <div className="flex flex-col gap-4">
        <DashboardMetrics />
        <SwimLanes
          actionItems={actionItems}
          actionItemsCounts={actionItemsCounts}
          isLoadingActionItems={isLoading}
          isLoadingLanes={isLoading}
          lanes={isLoading ? [] : (lanes ?? [])}
          statusFilterOptionsList={statusFilterOptionsList}
          title="Action Items"
        />
      </div>
    </AppWrapper.WithSidebar>
  );
};

export default Template;
